import { useFeatureIsOn } from '@growthbook/growthbook-react';
import { useAppConstantsContext } from '@/context/AppConstants';
import { Stack, Text } from '@/theme/index';

export const TitleBrandsHowItWorks = () => {
  const {
    data: { brandName },
  } = useAppConstantsContext();

  const isInUnlockTitlesVariation = useFeatureIsOn('bump-3416');

  return (
    <Stack
      direction="column"
      fontSize="0.9rem"
      spacing={1}
      color={(theme) => theme.palette.grey[800]}
      data-testid="how-it-works-title-brands"
    >
      <Text variant="body2" component="span">
        {isInUnlockTitlesVariation ? brandName : 'Brands'} are descriptive
        labels (applied by state motor vehicle titling agencies) regarding the
        status of a motor vehicle, such as "junk," "salvage," and "flood."
        NMVTIS keeps a history of brands that have been applied to the vehicle
        by any state. Brand information may help protect consumers from
        purchasing a damaged vehicle that is presented for sale without
        disclosure of the vehicle’s real condition. Without knowing the brand
        history, a consumer may pay more than a vehicle’s true value or purchase
        a vehicle that has not been adequately repaired and is not safe to
        drive.
      </Text>
    </Stack>
  );
};
